import { render, staticRenderFns } from "./forDates.vue?vue&type=template&id=5a5d4966"
import script from "./forDates.vue?vue&type=script&lang=js"
export * from "./forDates.vue?vue&type=script&lang=js"
import style0 from "./forDates.vue?vue&type=style&index=0&id=5a5d4966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports